import { ReactNode } from 'react'

interface FormFieldProps {
  label: string
  error?: string
  required?: boolean
  children: ReactNode
  /** Optional description below the label */
  description?: string
  /** Optional className for the wrapper */
  className?: string
}

/**
 * FormField - A wrapper component for form inputs with inline error display
 *
 * Usage:
 * ```tsx
 * <FormField label="Email" error={errors.email} required>
 *   <input type="email" className="input" value={email} onChange={...} />
 * </FormField>
 * ```
 */
export function FormField({
  label,
  error,
  required = false,
  children,
  description,
  className = '',
}: FormFieldProps) {
  return (
    <div className={className}>
      <label className="label">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {description && (
        <p className="text-xs text-gray-500 mb-1">{description}</p>
      )}
      {children}
      {error && (
        <p className="mt-1 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}

export default FormField
